import React from "react";
import { connect } from "react-redux";
import DynamicForm from "../../../components/dynamicscreens/DynamicForm";
import { EnquiryStatusJson } from "../../../DynamicFormsJson/MastersJSON/enquiryStatus";

class EnquiryIntrestedProductForm extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <>
                <DynamicForm
                    formPath={EnquiryStatusJson.formPath}
                    screenTitle={EnquiryStatusJson.screenTitle}
                    fieldMeta={EnquiryStatusJson.fieldMeta}
                    tableColumnsToFilter={EnquiryStatusJson.tableColumnsToFilter}
                    apiBaseURL={EnquiryStatusJson.apiBaseURL}
                    baseIdColumn={EnquiryStatusJson.baseIdColumn}
                    type={0}
                    isLog={true}
                />
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    enquiryStatus: state.enquiryOperations,
});

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(EnquiryIntrestedProductForm);